import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles({ name: 'EmobilityExplorePanel' })(theme => ({
	root: {

	},
	grid: {
		height: 'auto',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		[theme.breakpoints.up('md')]: { height: '372px' },
		[theme.breakpoints.up('lg')]: { height: '450px' }
	},
	explore: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		marginLeft: '25px',
		marginRight: '25px',
		paddingTop: '50px',
		paddingBottom: '50px',
		[theme.breakpoints.up('sm')]: {
			paddingTop: '70px',
			paddingBottom: '60px',
			maxWidth: '410px',
			marginLeft: 'auto',
			marginRight: 'auto'
		},
		[theme.breakpoints.up('md')]: {
			maxWidth: '310px',
			marginRight: '20px',
			paddingTop: '0px',
			paddingBottom: '0px',
			alignItems: 'flex-start'
		},
		[theme.breakpoints.up('lg')]: {
			maxWidth: '350px',
			marginRight: '0px'
		},
		[theme.breakpoints.up('xl')]: {
			maxWidth: '487px',
			marginRight: '-18px'
		}
	},
	title: {
		fontWeight: 'bold',
		fontSize: '28px',
		lineHeight: '36px',
		marginBottom: '6px',
		[theme.breakpoints.up('sm')]: {
			marginBottom: '15px'
		},
		[theme.breakpoints.up('md')]: {
			fontSize: '32px',
			lineHeight: '38px',
			marginBottom: '17px'
		},
		[theme.breakpoints.up('xl')]: {
			fontSize: '36px',
			lineHeight: '44px',
			marginBottom: '10px'
		}
	},
	text: {
		fontSize: '16px',
		lineHeight: '24px',
		[theme.breakpoints.up('md')]: {
			marginBottom: '30px'
		},
		[theme.breakpoints.up('lg')]: {
			marginBottom: '50px'
		},
		[theme.breakpoints.up('xl')]: {
			fontSize: '18px',
			lineHeight: '28px',
			marginBottom: '50px'
		},
		'&:last-child': {
			marginBottom: '0'
		}
	},
	image: {
		width: '130%',
		marginTop: '-10%',
		height: 'auto',
		[theme.breakpoints.up('sm')]: {
			width: 'unset',
			height: '300px',
			marginTop: '-51px',
			marginBottom: '-16px'
		},
		[theme.breakpoints.up('md')]: {
			display: 'none'
		}
	},
	rowImageDesktop: {
		display: 'none',
		[theme.breakpoints.up('md')]: {
			display: 'block'
		}
	},
	imageDesktop: {
		height: '355px',
		width: 'auto',
		marginLeft: '-15px',
		marginTop: '-50px',
		marginRight: 'auto',
		[theme.breakpoints.up('lg')]: {
			height: '400px',
			marginLeft: '-43px',
			marginTop: '-70px',
			marginRight: 'auto'
		},
		[theme.breakpoints.up('xl')]: {
			height: '500px',
			marginLeft: '-45px',
			marginTop: '-70px',
			marginRight: 'auto'
		}
	},
	'layer-0': {

	},
	'layer-1': {

	},
	'layer-2': {

	}
}));
